import { useAuth } from "../context/auth";
import { Navigate, Outlet } from "react-router";
import Loading from "../components/Loading";

export default function DashboardRoutes() {
    const auth = useAuth();
    if(auth.loading) {
        return (
            <Loading />
        )
    }
    return auth.user.role === 'dashboard' || auth.user.role === 'admin' ? <Outlet /> : <Navigate to="/" />
}